"use client"

import { useState } from "react"
import { ChevronDown } from "lucide-react"
import "./grades.css"

const GradesTwo= () => {
  const [activePhase, setActivePhase] = useState(1)
  const [showDetails, setShowDetails] = useState(false)
  const [activeTab, setActiveTab] = useState(0)

  const phases = [
    {
      id: 1,
      number: 1,
      title: "مرحلة البناء الشخصي  ",
      description:"ورشتا عمل ترسخان مفهوم القيادة والممارسة الأخلاقية والمهنية له، من خلال فهم انماط البشر والقيم التي يصح أن تحكم إدارتهم سواء كانت شخصية للقائد أو تنظيمية في المنظمة.",
      
      details: [
        {
          tab: " الشخصــية القيــادية",
          content: [
           "أنواع الشخصية والذكاء العاطفي",
           "أنماط القيادة وتفعيلها",
           "القيم الشخصية والمؤسسية",
           "القيادة الرحيمة وعقلية المواجهة",
           "التعاطف وبناء الثقة",

          ]
        },
        {
          tab: " الاخلاق المهنية",
          content: [
          "أخلاقيات العمل والتصرف الأخلاقي",
     "المهمة الشخصية",
     "مواءمة الدور والغاية",
     "القدوة والالتزام",
     "المحادثات المثمرة",
 
           ]
        },
       
      ],
    },
    {
      id: 2,
      number: 2,
      title: "مرحلة البناء التنظيمي  ",
      description:
        "ورشتا عمل تناقشان مفاهيم الاستراتيجية وإدارة التغيير بناء على فهم دوافع وأهداف المنظمة وأفرادها. كما تناقشان كيفية تأسيس ثقافة المشاركة ودعم الإبداع وإلهام العاملين.",
      details: [
        {
          tab: " الاستراتيجــية والتغــيير",
          content: [
            "التخطيط والتفكير الاستراتيجي",
       " النماذج الاستراتيجية ومفهوم التغيير",
       "  نماذج التغيير وإدارة المقاومة",
       "إدارة المخاطر التنظيمية ",
       "الريادة التنظيمية وإدارة النمو ",
   
             ]
        },
        {
          tab: "الإبــداع التشــاركي",
          content: [
          'النظرة المستقبلية والقيادة الرقمية',
          'رصد التوجهات وتخطيط السيناريوهات',
          'تفعيل الإبداع التنظيمي',
          'المشاركة ونمذجة الدور',
          'الإلهام وإدارة الابتكار',
   
             ]
        },
      
      ],
    },
    {
      id: 3,
      number: 3,
      title: " مرحلة تفعيل الجهود ",
      description:
        "ثلاث ورش عمل تتناول شروط وآليات بيئة العمل الفعالة، وما يستتبعها من ممارسات إدارة الأداء وتحقيق النتائج، ثم تقييم الأداء وتوجيه الأفراد وتطوير قدراتهم.",
      details: [
        {
          tab: " بيئــة العمــل",
          content: [
           'العافية المهنية والتوازن النفسي',
           'قيادة الأداء المهني',
           'الإرشاد في بيئة العمل',
           'التوظيف والتاهيل وإدارة الخروج',
           'سياق وتقنيات التوجيه المهني'
     
               ]
        },
        {
          tab: "الأداء والإنتــاج",
          content: [
           'بيئة العمل والتوازن النفسي',
           'عقلية النمو وإدارة الأزمات',
           'القيادة الرشيقة',
      
                ]
        },
        {
          tab: "التقــييم والتطــوير",
          content: [
            'الإرشاد والتوجيه في بيئة العمل',
            'التوظيف والتأهيل والتعاقب   ',
            'إدارة المواهب ',
       
                 ]
        },
      ],
    },
    {
      id: 4,
      number: 4,
      title: "مرحلة تطوير الممارسة    ",
      description: "ثلاث ورش عمل تبني على نتائج الأداء في تطوير الوسائل. فتناقش معايير صناعة القرار وآليات المشاركة وتشجيع التفاعل، وفي إطار تأسيس علامة شخصية وصيانتها وتطويرها.",
      details: [
        {
          tab: " التفــويض والتفــاعل",
          content: [
            '  التعلم الرسمي وغير الرسمي  ',
            ' التعلم التجريبي والتغذية الراجعة    ',
            'المشاركة والتعلم بالممارسة  ',
       
                 ]
        },
        {
          tab: "صنــاعة القــرار",
          content: [
            ' التفكير الناقد وتحليل الفجوة',
            ' التكلفة والعائد وتقييم البدائل',
            'مواطنة المنظمة  ',
       
                 ]
        },
        {
          tab: "العــلامة الشخصــية",
          content: [
            'السمعة والمصداقية ',
            ' التركيز وإدارة الأولويات   ',
            ' تخطيط التطوير الشخصي  ',
       
                 ]
        },
      ],
    },
    {
      id: 5,
      number: 5,
      title: "مرحلة النمو التأثير  ",
      description: "ثلاث ورش عمل تعزز العمل الجماعي وتنمي مهارات بناء علاقات العمل داخل المنظمة ومع الأطراف الخارجية، وتصقل ممارسات التخطيط والإدارة التشغيلية.",
      details: [
        {
          tab: " العمــل الجمــاعي",
            content: [
               "النماذج السلوكية لفرق العمل",
               "الحساسية الاجتماعية",
               "التحيز غير الواعي والذكاء الثقافي",
            ],
        },
        {
          tab: "إدارة العلاقــات",
          content: [
        'التشبيك وآلياته',
        'التواصل الرسمي وغير الرسمي',
        'الحسم والوساطة بين ذوي المصلحة',
         ],
        },
        {
          tab: "الإدارة التنفيــذية",
          content: [
            ' إدارة الاجتماعات والسلوك المرفوض',
          'الجانب البشري وقيادة المشروعات',
          'إدارة النزاع في بيئة متعددة الثقافات',
             ],
        },
      ],
    },
  ]

  const handlePhaseClick = (phaseId) => {
    setActivePhase(phaseId)
    setShowDetails(false)
  }

  const toggleDetails = () => {
    setShowDetails(!showDetails)
    setActiveTab(0)
  }

  const handleTabClick = (index) => {
    setActiveTab(index)
  }

  const activePhaseData = phases.find((phase) => phase.id === activePhase)

  return (
    <div className="program-design-container">
      <div className="program-header-g">
        <h2 className="program-title">فلسفة تصميم البرنامج</h2>
        <div className="program-subtitle">
        يمتد البرنامج اثني عشر شهرا، يمر فيها المشارك بخمس مراحل، تتضمن ثلاثة عشر ورشة عمل منفصلة متصلة.


</div>
      </div>

      <div className="program-content">
        <div className="phases-details">
          <h3 className="details-title">تفاصيل المرحلة</h3>
          <div className="details-content">{activePhaseData.description}</div>

          <button className="details-toggle" onClick={toggleDetails}>
            <span>تفاصيل المرحلة</span>
            <ChevronDown className={`details-icon ${showDetails ? "rotated" : ""}`} />
          </button>

          {showDetails && (
  <div className="details-tabs">
    <div className="tabs-header">
      {activePhaseData.details.map((detail, index) => (
        <button
          key={index}
          className={`tab-button ${activeTab === index ? "active" : ""}`}
          onClick={() => handleTabClick(index)}
        >
          {detail.tab}
        </button>
      ))}
    </div>
    <div className="tab-content">
      <ul>
        {activePhaseData.details[activeTab].content.map((item, index) => (
          <li key={index}><i class="far fa-check-circle"></i>{item}</li>
        ))}
      </ul>
    </div>
  </div>
)}

        </div>

        <div className="phases-list">
          {phases.map((phase) => (
            <div
              key={phase.id}
              className={`phase-item ${activePhase === phase.id ? "active" : ""}`}
              onClick={() => handlePhaseClick(phase.id)}
            >
              <div className="phase-number">{phase.number}</div>
              <div className="phase-title">{phase.title}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default GradesTwo
